import { ApiService } from "Services/ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export const GoogleAuthApiSlice = ApiService.injectEndpoints({
    endpoints: (builder) => ({
        googleLogin: builder.mutation<ResultsDTO, { token: string }>({
            query: ({ token }) => ({
                url: '/auth/google',
                method: 'POST',
                body: { token }
            }),
        })
    })
});

export const { useGoogleLoginMutation } = GoogleAuthApiSlice;
